{
    "warning": "ADVARSEL!",
    "message": "Undlad at indtaste eller indsætte kode, som du ikke forstår.\nBrug af denne konsol kan sætte hackere i stand til at efterligne dig og stjæle dine oplysninger ved hjælp af et angreb ved navn Self-XSS."
}
